export namespace Alerts {
    let SetupAlerts = () => {
        $('.js-close-alert').on('click', function () {
            $(this).closest('.alert').fadeOut().remove();
        });
    };
    export const init = () => {
        SetupAlerts();
    };
}
